import * as React from 'react';
import { v2 } from '@fieldnation/platform-components';
import TimelinessScore from '../index';
import CloseButton from '../../common/components/CloseButton';
import { IReliabilityScore, ScoreType } from './types.d';

const { Modal } = v2;

interface TimelinessDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  providerId: number;
  reliabilityScore: IReliabilityScore;
}

export default function TimelinessDetails(props: TimelinessDetailsProps): JSX.Element {
  const {
    isOpen, onClose, providerId, reliabilityScore,
  } = props;
  const timelinessScorePayload = reliabilityScore?.[ScoreType.Timeliness] ?? {};
  return (
    <Modal
      isOpen={isOpen}
      header="Check-in details"
      onClose={onClose}
      size="medium"
      position="center"
    >
      <TimelinessScore timelinessData={timelinessScorePayload} providerId={providerId} />
      <CloseButton onClose={onClose} />
    </Modal>
  );
}
